import { attributes, type HtmlValue, html } from 'BomdisoftComponents/html/index';
import { CHECK_CIRCLE_OUTLINE_OUTLINED_GLYPH, CLOSE_ROUNDED_GLYPH, ERROR_OUTLINE_OUTLINED_GLYPH, INFO_OUTLINED_GLYPH, REPORT_PROBLEM_OUTLINED_GLYPH } from 'BomdisoftComponents/icons/glyphs';
import { type IconGlyph, renderIcon } from 'BomdisoftComponents/icons/render';
import type { SnackbarQueueItem, SnackbarVariant } from 'BomdisoftComponents/notifications/snackbars/queue';
import { renderTooltip } from 'BomdisoftComponents/tooltip/render';

export const SNACKBARS_TAG = 'bomdisoft-snackbars';

export const SNACKBAR_GLYPHS: Readonly<Record<SnackbarVariant, IconGlyph | null>> = {
  default: null,
  error: ERROR_OUTLINE_OUTLINED_GLYPH,
  info: INFO_OUTLINED_GLYPH,
  success: CHECK_CIRCLE_OUTLINE_OUTLINED_GLYPH,
  warning: REPORT_PROBLEM_OUTLINED_GLYPH,
};

export const toSnackAttributes = ({ indicator, surface, variant }: Pick<SnackbarQueueItem<unknown>, 'indicator' | 'surface' | 'variant'>) => ({
  'data-indicator': indicator,
  'data-surface': surface,
  'data-testid': 'snackbar',
  'data-variant': variant,
  role: variant === 'error' ? 'alert' : 'status',
});

const renderMarker = ({ indicator, variant }: Pick<SnackbarQueueItem<HtmlValue>, 'indicator' | 'variant'>) => {
  if (indicator === 'dot') return html`<span aria-hidden="true" class="bomdisoft-snack-dot"></span>`;
  const glyph = SNACKBAR_GLYPHS[variant];
  if (indicator !== 'icon' || glyph === null) return '';
  return html`<span aria-hidden="true" class="bomdisoft-snack-icon">${renderIcon(glyph, { size: 'inherit' })}</span>`;
};

export const renderSnack = (item: SnackbarQueueItem<HtmlValue>, closeLabel: string, closeTooltipId = `bomdisoft-snack-close-tooltip-${item.id}`) =>
  html`<div${attributes({ class: 'bomdisoft-snack', ...toSnackAttributes(item) })}>${renderMarker(item)}<span class="bomdisoft-snack-message"><span class="bomdisoft-snack-title">${item.message}</span>${item.description === undefined ? '' : html`<span class="bomdisoft-snack-description">${item.description}</span>`}</span>${renderTooltip({ children: html`<button${attributes({ 'aria-label': closeLabel, class: 'bomdisoft-snack-close', 'data-testid': 'snackbar-close', type: 'button' })}>${renderIcon(CLOSE_ROUNDED_GLYPH, { size: 16 })}</button>`, id: closeTooltipId, title: closeLabel })}${item.customAction && item.customActionText ? html`<span class="bomdisoft-snack-actions"><button class="bomdisoft-snack-action" data-testid="snackbar-action" type="button">${item.customActionText}</button></span>` : ''}</div>`;

export const renderSnackbarRegion = ({ anchor, snacks }: { anchor: string; snacks: HtmlValue }) => html`<div${attributes({ class: 'bomdisoft-snackbars-region', 'data-anchor': anchor })}>${snacks}</div>`;
